<script>
import Layout from '../../layouts/auth'

import appConfig from '@/app.config'
import { email, required } from 'vuelidate/lib/validators'
import { LOGIN } from '@/services/api/auth'
import axios from 'axios'
import jwt_decode from 'jwt-decode'
import Aes from '@/pkg/aes-256-cbc'
// import { getVSMSClient } from '@/services/vsms'
// import { getClient, getPrivateClient } from '@/services/identity'
// import { setCookie } from '@/pkg/cookie'

// const vsmsAxios = getVSMSClient()
// const IdentityClientPrivate = getPrivateClient()
// const IdentityClient = getClient()

/**
 * Login component
 */
export default {
  page: {
    title: 'Login',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      submitted: false,
      authError: null,
      tryingToLogIn: false,

      mode: this.$store.state.config.mode,

      backgroundLogin: {
        backgroundImage: `url(${require('@/assets/images/login.png')})`,
      },
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
  },
  methods: {
    // Try to log the user in with the username
    // and password they provided.
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    async tryToLogIn() {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      } else {
        this.tryingToLogIn = true
        this.authError = null
        const input = {
          email: this.email,
          password: this.password,
          timezoneOffset: new Date().getTimezoneOffset(),
        }
        if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
          const resource = JSON.stringify(this.getManifest())
          console.log(await Aes.encrypt(resource))
        } else {
          this.$apollo
            .mutate({
              mutation: LOGIN,
              variables: {
                input: input,
              },
            })
            .then((response) => {
              if (response.data.login.isSuccessful) {
                axios
                  .post('/auth/login', {
                    email: this.email,
                    password: this.password,
                  })
                  .then((responAxio) => {
                    this.tryingToLogIn = false
                    const decodedToken = jwt_decode(responAxio.data.token)
                    const subCode = []
                    var keyss = JSON.parse(decodedToken.right)

                    var rightsCode = Object.keys(keyss)
                    rightsCode.forEach((element) => {
                      keyss[element].forEach((sub) => {
                        subCode.push(Object.keys(JSON.parse(sub))[0])
                      })
                    })
                    localStorage.removeItem('token')
                    localStorage.removeItem('tokenAccess')
                    localStorage.setItem('tokenAccess', responAxio.data.token)
                    localStorage.setItem('token', response.data.login.data.token)
                    localStorage.setItem('right', rightsCode)
                    localStorage.setItem('rightSub', subCode)
                    localStorage.setItem('domainName', `${window.location.host}`)
                    localStorage.setItem('email', this.email)
                    window.location.href = '/'
                  })
                  .catch((err) => {
                    this.tryingToLogIn = false
                    err = 'email dan password tidak sesuai!'
                    this.$toast.warning(err)
                  })
              } else {
                this.$toast.warning(response.data.login.message)
              }
            })
        }
      }
    },
    getManifest() {
      let manifest = {}
      manifest = {
        url: `${process.env.VUE_APP_API_VSMS_URL}/internal/user/auth`,
        form: [
          {
            field: "email",
            placeholder: "Email or Phone",
            type: "text",
          },
          {
            field: "password",
            placeholder: "Kata Sandi",
            type: "password",
          },
        ],
        redirect_format: `${process.env.VUE_APP_SMS}?isLoginSuccess=true`,
        // redirect mecare
      }
      return manifest
    },
  },
  async mounted() {
    if (process.env.VUE_APP_INTEGRATE_IDENTITY === 'true') {
      let platform = 'websms'
      console.log("TEST env", process.env.NODE_ENV)
      if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'release') {
        platform = platform + '-stg'
      } else if (process.env.NODE_ENV === 'development') {
        platform = platform + '-dev'
      }
      const resource = JSON.stringify(this.getManifest())
      const encryptedResource = await Aes.encrypt(resource)
      window.location = `${process.env.VUE_APP_IDENTITY_HOST}/login?platform=${platform}&resource=${encryptedResource}`
    }
  },
}
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-md-8 col-lg-8 col-xl-9 mc-auth__banner" :style="backgroundLogin"></div>
      <div class="col-md-4 col-lg-4 col-xl-3 mc-auth__form">
        <div class="mc-auth__logo mt-5">
          <h1>
            <router-link to="/">
              <img src="@/assets/images/vsms-full.svg" alt />
            </router-link>
          </h1>
        </div>
        <div class="mc-auth__form-wrapper">
          <p class="mc-auth__label">Login to Account</p>

          <b-form class="mc-auth__form-wrapper-deep" @submit.prevent="tryToLogIn">
            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>

            <b-form-group class="mb-3" id="input-group-1" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="email"
                type="text"
                placeholder="Email"
                :class="{ 'is-invalid': submitted && $v.email.$error }"
              ></b-form-input>

              <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                <span v-if="!$v.email.required">Email tidak boleh kosong.</span>
                <span v-if="!$v.email.email">Format email tidak sesuai.</span>
              </div>
            </b-form-group>

            <b-form-group class="mb-2 form-password" id="input-group-2" label-for="input-2">
              <b-form-input
                v-if="showPassword"
                id="input-2"
                v-model="password"
                type="text"
                placeholder="Kata Sandi"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
              ></b-form-input>
              <b-form-input
                v-else
                id="input-2"
                v-model="password"
                type="password"
                placeholder="Kata Sandi"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
              ></b-form-input>
              <i
                @click="togglePassword"
                class="mc-fa-password"
                :class="{
                  'icon-outline_eye-off': showPassword,
                  'icon-outline_eye': !showPassword,
                }"
              ></i>
              <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                Kata sandi tidak boleh kosong.
              </div>
            </b-form-group>

            <b-form-group class="form-check">
              <b-form-checkbox
                id="checkbox-1"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
                v-if="mode == 'development'"
              >
                Ingat Saya
              </b-form-checkbox>
              <span class="mc-auth__flag">
                <img src="@/assets/images/flags/us.jpg" alt v-if="mode == 'development'" />
              </span>
            </b-form-group>

            <div class="mt-5 d-grid">
              <b-button type="submit" variant="primary" class="btn-block">Masuk</b-button>
              <a class="text-primary d-block text-center mt-3" v-if="mode == 'development'"
                >Lupa Kata Sandi</a
              >
            </div>

            <b-alert show variant="warning" v-if="mode == 'development'" class="mt-3"
              >Development Mode</b-alert
            >
            <b-alert show variant="warning" v-if="mode == 'staging'" class="mt-3"
              >Staging Mode</b-alert
            >
          </b-form>
        </div>
        <div class="mc-auth__copyright">
          <span
            >Dipersembahkan oleh <img src="@/assets/images/mceasy.png" alt height="18" class="ms-2"
          /></span>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
